<template>
  <el-dialog title="采购订单审核" class="global-dialog" :visible.sync="showDlg" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        ref="form2" :rules="rules" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="orderState" label="订单状态">
              <el-select v-model="formData.orderState" placeholder="请选择订单状态">
                <el-option v-for="[key, value] of ycOrderStateMap" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="formData.orderState === '2'">
            <el-form-item prop="supplierName" label="保证金">
              <el-input v-model="formData.purchasePrice" placeholder="请输入保证金"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="formData.orderState === '2'">
            <el-form-item prop="supplierName" label="付款日期">
              <el-date-picker v-model="formData.purchaseDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="formData.orderState === '2'">
            <el-form-item prop="fileList" label="付款附件">
              <file-upload v-model="formData.priceFileList" :maxSize="20"></file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审批意见" prop="remark">
              <el-input type="textarea" v-model="formData.remark" placeholder="请输入审批意见"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button @click="submitDlg" type="primary">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
// import { ycOrderState } from '../../utils/dict'
// import { deepClone } from '../../utils/utils'
export default {
  name: 'PurchaseOrdersDialog',
  props: {
    showDlg: {
      type: Boolean,
      default: false
    },
    dataInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      formData: {
        orderId: '', // 订单ID
        orderState: '', // 订单状态2审批通过3结束订单4已驳回
        remark: '', // 审批意见
        purchasePrice: '', // 付款价格 状态2时可填
        purchaseDate: '', // 付款日期 状态2时可填
        priceFileList: [] // 付款附件列表 状态2时可填
      },
      loading: false,
      rules: {
        orderState: [{ required: true, message: '请选择订单类型' }]
      }
    }
  },
  created() {
    this.formData.orderId = this.dataInfo.orderId
  },
  computed: {
    ycOrderStateMap() {
      // const data = deepClone(ycOrderState)
      // data.delete('1')
      const map = new Map()
      map.set('2', '审批通过')
      map.set('4', '审批驳回')
      return map
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:showDlg', false)
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        console.log(this.formData)
        if (this.formData.orderState === '2' && this.formData.purchasePrice) {
          if (!this.formData.purchaseDate) {
            this.$message.error('请选择付款日期')
            return
          }
        }
        this.loading = true
        const url = this.$apis.purchaseOrders.approveYcnPurchaseOrder
        this.$axios.post(url, this.formData).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    }

  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
